import React from 'react';

const SavedSearchesDropdown = ({ searches, onSelectSearch, onClose }) => {
  return (
    <div className="saved-searches-dropdown">
      <div className="dropdown-header">
        <h3>Recent Searches</h3>
        <span className="close-icon" onClick={onClose}>&times;</span>
      </div>
      <div className="dropdown-content">
        {searches.length === 0 ? (
          <p className="no-searches-message">No recent searches found.</p>
        ) : (
          <ul className="searches-list">
            {searches.map((search, index) => (
              <li key={index} onClick={() => {
                onSelectSearch(search);
                onClose();
              }}>
                {search.query} {search.startDate && search.endDate ? `(${search.startDate} to ${search.endDate})` : ''}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SavedSearchesDropdown; 